/* @flow */

import { createSlice } from '@reduxjs/toolkit';

import { patchEntities } from 'src/shared/core/util/reducerUtils';

import * as entititesTypes from 'src/shared/domain/base/action/entityActionTypes';
import { notificationsEndpoint } from 'src/shared/app/base/settings/endpointSettings';

export const entitiesNotificationSlice = createSlice({
  name: 'notification',
  initialState: {},
  reducers: {},
  extraReducers: {
    [entititesTypes.PATCH_ENTITIES](state, action) {
      return patchEntities(state, action, 'notifications');
    },
  },
});

type fetchNotificationsParams = {
  unread?: boolean,
  limit?: number,
};

export function fetchNotifications(
  url: ?string,
  params: ?fetchNotificationsParams = {},
) {
  return (dispatch: any, getState: any, { get }: Object) =>
    get(
      url || notificationsEndpoint(),
      !url && {
        ...params,
        for_platform: 'pax',
      },
    );
}

export default entitiesNotificationSlice.reducer;
